import { Injectable} from '@angular/core'
import {ActivatedRoute, Router} from '@angular/router'
import {filter, map, shareReplay, take, tap} from 'rxjs'


export const enum PaymentStatus {
  SUCCESS = 'success',
  ALREADY_PAID = 'already_paid',
  FAILED = 'failed',
}

export enum PaymentSource {
  MONTONIO = 'montonio'
}

@Injectable({
  providedIn: 'root'
})
export class PaymentStatusHelper {
  private status$ = this.activatedRoute.queryParamMap.pipe(
    filter(params => {
      const paymentSource = params.get('paymentSource')
      return Object.values(PaymentSource).includes(paymentSource as PaymentSource)
    }),
    take(1),
    map(params => params.get('paymentStatus')),
    shareReplay(),
    tap( () => this.cleanUpReceivedParams())
  )

  isShown$ = this.status$.pipe(
    map(Boolean)
  )

  isSuccessful$ = this.status$.pipe(
    filter(Boolean),
    map((status) => status === PaymentStatus.SUCCESS)
  )

  isFailed$ = this.status$.pipe(
    filter(Boolean),
    map((status) => status === PaymentStatus.FAILED)
  )


  private cleanUpReceivedParams() {
    this.router.navigate([], {
      replaceUrl: true,
      queryParams: {
        'paymentStatus': null,
        'paymentSource': null,
      },
      queryParamsHandling: 'merge'
    })
  }
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
  }
}
